import { useQuery } from "@tanstack/react-query";
import { api } from "../../data";
import { asLang, LangContext, useLang, useT, type Lang } from "../../lib/sprache";

export { asLang, dateOf, monthOf, monthShortOf, numOf, pctOf, tr, type Lang } from "./lang";

/**
 * Sprache des Creator-Portals (Befund 14): eigene Wahl im Profil (user_preferences.language) → Sprache des Profils
 * (talents.language, für Mails) → Dokumentsprache der Agentur → Deutsch. Kontext und Hilfen teilt es mit der
 * Agentur-Oberfläche (lib/sprache.ts).
 */
export const CreatorLangContext = LangContext;
export { useLang, useT };

export interface CreatorPrefs {
  lang: Lang;
  igEnabled: boolean;
}

/** Sprache und Instagram-Freischaltung für Rahmen und Navigation (klein, eine Abfrage je Profil). */
export function useCreatorPrefs(userId: string | null, talentId: string, orgLanguage: string | null | undefined): CreatorPrefs {
  const q = useQuery({
    queryKey: ["creator", talentId, "prefs", userId],
    enabled: !!userId,
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const [prefs, talent] = await Promise.all([
        api.select<{ language: string | null }>("user_preferences", { columns: "language", filters: [["user_id", "eq", userId!]] }).catch(() => []),
        api.select<{ language: string | null; ig_enabled: boolean }>("talents", { columns: "language, ig_enabled", filters: [["id", "eq", talentId]] }).catch(() => []),
      ]);
      return { own: prefs[0]?.language ?? null, talent: talent[0]?.language ?? null, ig: !!talent[0]?.ig_enabled };
    },
  });
  const lang = asLang(q.data?.own) ?? asLang(q.data?.talent) ?? asLang(orgLanguage) ?? "de";
  return { lang, igEnabled: q.data?.ig ?? false };
}
